module.exports = __webpack_public_path__ + "media/images/lb/783-e36e99fdc549d709cc111fe0a97f12ba.svg";